import { render } from "./ComboBoxPessoaRM.vue?vue&type=template&id=a5159d1e"
import script from "./ComboBoxPessoaRM.vue?vue&type=script&lang=js"
export * from "./ComboBoxPessoaRM.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__